import { createFileRoute, Link } from "@tanstack/react-router"
import { z } from "zod/v4"

import { Logo } from "@/components/logo"
import { AuthCallbackPage } from "@/pages/auth/callback/email/page"

const callbackSchema = z.object({
  mode: z.literal("magic"),
  token: z.string().min(1, "Token é obrigatório"),
  remember: z.coerce.boolean().optional().default(true),
})

// Omit path validation here to satisfy TSC before route generation
export const Route = createFileRoute("/auth/callback/email")({
  validateSearch: (search) => callbackSchema.parse(search),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link to="/" className="flex items-center self-center">
          <Logo size="lg" />
        </Link>
        <AuthCallbackPage />
      </div>
    </div>
  )
}
